import CinemaTable from './cinema-table.vue';
export default CinemaTable;
